import {
  // CustomSeriesOption,
  EChartsOption,
  // graphic,
  LineSeriesOption,
} from "echarts";
// import { generateNumbers } from "@/utils/math";
import Decimal from "decimal.js";

export type PlayStatus = "play" | "pause" | "stop";

const defaultMax = 0.8;

export const getMax = (list1: number[][], list2: number[][]) => {
  const value1 = list1?.map((item) => item[1]) || [];
  const value2 = list2?.map((item) => item[1]) || [];
  let max = Math.max(...value1, ...value2);
  if (max !== -Infinity) {
    const decimalMaxF = new Decimal(max);
    max = decimalMaxF.plus(0.1).toDecimalPlaces(1).toNumber();
    if (max < defaultMax) return defaultMax;
    return max;
  }
  return 1;
};

function generateTimestamps(
  durationSeconds: number,
  intervalMilliseconds: number,
  direction: "forward" | "backward" = "backward"
) {
  const numTimestamps = Math.floor(
    (durationSeconds * 1000) / intervalMilliseconds
  );
  const timestamps = [];
  const now = Date.now();
  for (let i = 0; i < numTimestamps; i++) {
    const interval = i * intervalMilliseconds;
    const value = direction === "backward" ? now - interval : now + interval;
    timestamps.push(value);
  }
  return timestamps;
}

const getDefaultSeriesdataOptions = () => {
  return generateTimestamps(10, 60).map((v) => [v]);
};
// export const decreasingSequence = generateNumbers(2, 0);
export const decreasingSequence = getDefaultSeriesdataOptions();
export const getDefaultSeriesData = () => {
  // const data = getDefaultSeriesdataOptions()
  const res = {
    UIRx_SuspHgtAmp_FL: [], // valueRR
    UIRx_SuspHgtAmp_FR: [], // valueRR
    UIRx_SuspHgtAmp_RL: [], // valueRR
    UIRx_SuspHgtAmp_RR: [], // valueRR
  } as DomianControl.DURSeriesData;
  return res;
};

export const optionseries1 = () => [
  {
    id: "UIRx_SuspHgtAmp_FL",
    name: "悬架高度波动幅值FL",
    color: "#03b152",
  },
  {
    id: "UIRx_SuspHgtAmp_FR",
    name: "悬架高度波动幅值FR",
    color: "#ffc101",
  },
];
export const optionseries2 = () => [
  {
    id: "UIRx_SuspHgtAmp_RL",
    name: "悬架高度波动幅值RL",
    color: "#ff0301",
  },
  {
    id: "UIRx_SuspHgtAmp_RR",
    name: "悬架高度波动幅值RR",
    color: "#0372bf",
  },
];

export const getDefaultSeriesProp = () =>
  ({
    type: "line",
    showSymbol: false,
    symbol: "circle",
    symbolSize: 6,
    lineStyle: {
      width: 2,
    },
    clip: true,
    data: [],
  } as LineSeriesOption);

// 每 100 毫秒生成一个时间戳 生成一个 3 秒的时间戳列表
export const getChartsDefaultOptions = (index: number) => {
  let seriesList = [optionseries1(), optionseries2()][index] || optionseries1();
  // const xAxisDate = generateNumbers(3, 0).reverse();
  const data = [...decreasingSequence];
  // const max = [1.6, 1.6][index];
  // const min = [0, 0][index];

  seriesList = seriesList?.map((item: any) => ({
    ...getDefaultSeriesProp(),
    ...item,
    data,
  }));
  const lineColor = "rgba(199, 237, 250,0.2)";
  // const interval = (index: number, value: string) => {
  //   // 判断 value 是整数
  //   return Number.isInteger(Number(value)) ? value : "";
  // };
  return {
    backgroundColor: "#032f2b",
    animation: false,
    //   legend: {
    //     show: true,
    //     // x: "4%",
    //     top: "20px",
    //     data: ["123"],
    //     // type: "scroll",
    //     textStyle: {
    //       color: "#cccccc",
    //       fontWeight: 700,
    //       fontSize: 12,
    //     },
    //     formatter: function (name) {
    //       return name;
    //     },
    //   },
    title: {
      text: index === 0 ? "前轴" : "后轴",
      padding: [10, 0, 0, 20],
      textStyle: {
        color: "#fff",
      },
    },
    legend: {
      show: true,
      // type: 'scroll',
      // orient: 'vertical',
      right: 20,
      top: 10,
      // top: "10%",
      // bottom: 20,
    },
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#283b56",
        },
      },
    },
    grid: {
      top: 40,
      left: 25,
      right: 20,
      bottom: 30,
    },
    xAxis: {
      // name: "sec",
      // data: xAxisDate,
      type: "time",
      nameTextStyle: {
        color: "#fff",
      },
      // nameGap: -30,
      // minorTick: {
      //   show: true,
      // },
      // minorSplitLine: {
      //   show: true,
      //   lineStyle: {
      //     color: lineColor,
      //   },
      // },
      axisPointer: {
        snap: true,
        lineStyle: {
          color: "#8e96a1",
          width: 2,
        },
        label: {
          show: false,
          // formatter: function (params) {
          //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
          // },
          backgroundColor: "#3fafa5",
        },
        handle: {
          show: true,
          color: "#3fafa5",
          size: 30,
          margin: 10,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          shadowBlur: 0,
        },
      },
      splitLine: {
        show: true,
        // interval: 10,
        // interval: (index: number, value: string) => {
        //   return Number.isInteger(Number(value));
        // },
        lineStyle: {
          color: lineColor,
        },
      },
      axisLabel: {
        // show: index === 2 ? true : false, // 隐藏 x 轴标签
        // interval,
        // formatter: (number: string) => {
        //   console.log("[BOWEN_LOG] 🚀 ~~ getChartsDefaultOptions ~~ number:", number);
        //   return Number(number) % 5 === 0 || Number(number) === 1 ? number : "";
        // },
      },
      axisTick: {
        // interval,
      },
      axisLine: {
        onZero: false,
        lineStyle: {
          color: lineColor,
        },
      },
    },
    yAxis: {
      type: "value",
      min: 0,
      max: defaultMax,
      // min,
      // minorTick: {
      //   show: true,
      // },
      minorSplitLine: {
        show: false,
        lineStyle: {
          color: lineColor,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: lineColor,
        },
      },
      axisLine: {
        lineStyle: {
          color: lineColor,
        },
      },
      // axisPointer: {
      //   type: "line",
      //   snap: true,
      //   show: true,
      //   label: {
      //     show: false,
      //     // formatter: function (params) {
      //     //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
      //     // },
      //     backgroundColor: "#8e96a1",
      //   },
      // },
    },
    dataZoom: [
      {
        show: true,
        type: "inside",
        filterMode: "none",
      },
    ],
    series: seriesList,
  } as EChartsOption;
};
